// extracted by mini-css-extract-plugin
export var modalFooter = "_st-0";